import * as Sentry from '@sentry/nextjs';

import { YouInvest } from 'src/Api';
import { Main } from 'src/Layouts';
import { sendCacheHeaders } from 'src/Utils';

import MiniSearchBox from 'src/Components/Atoms/MiniSearchBox';
import { InvestWithAjBell } from 'src/Components/Molecules/Card';

export default function Unavailable({ instrumentData }) {

    const ctaData = [
        {
            key: 'investment-options',
            url: '/our-services/investment-options',
            image: 'img/investment-options.png',
            title: 'Investment options',
            description: 'Choose from a wide range of investments including shares, funds, investment trusts and ETFs.',
            button: 'See investment options'
        },
        {
            key: 'investment-ideas',
            url: '/investment-ideas',
            image: 'img/invest-ideas.png',
            title: 'Investment ideas',
            description: 'From Ready-made portfolios to our Favourite funds list, we\'re here to make it easier for you.',
            button: 'See investment ideas'
        },
        {
            key: 'share-screener',
            url: '/market-research/screener/shares',
            image: 'img/share-screener.png',
            title: 'Share screener',
            description: 'Find, filter and compare more than 14,000 stocks from across the world using our free share screener tool.',
            button: 'Compare our shares'
        }
    ];

    const ctaColumns = ctaData.map((item) => <div key={item.key} className="ajb-col-4 ajb-col-8-breakpoint">
        <div className="card margin-top-0 text-align-center large">
            <div className="card-image">
                <a href={item.url}><img alt={item.title} src={item.image} /></a>
            </div>
            <div className="card-content padding-top-30 padding-bottom-30">
                <span className="card-title h4 font-weight-thin">{item.title}</span>
                <p className="margin-bottom-0">{item.description}</p>
            </div>
            <div className="card-action">
                <a href={item.url} className="c-btn waves-effect waves-light button-outline button button--outline-grey full-width">{item.button}</a>
            </div>
        </div>
    </div>);

    return <Main title='Unavailable | AJ Bell' nav={instrumentData.nav} breadcrumb='Unavailable'>
        <div className="ajb-grid-row padding-bottom-20">
            <div className="ajb-col-2 ajb-col-8-breakpoint padding-top-20 padding-bottom-0-sm">
                <InvestWithAjBell />
            </div>
            <div className="ajb-col-10 ajb-col-8-breakpoint main-content-wrapper white-bg margin-top-20 padding-20 padding-10-sm">
                <div className="ajb-card unavailable">
                    <h2>Sorry, this page is unavailable.</h2>
                    <p><strong>The investment may have been removed or no longer exists on the AJ Bell platform.</strong></p>
                    <p>You can have another go at finding it by taking one of these steps:</p>
                    <ul className="browser-default margin-left-20">
                        <li>If you&apos;ve entered the page&apos;s URL manually, please check it for typos</li>
                        <li>Try navigating to it from our <a href="/">homepage</a></li>
                        <li>Enter the investment&apos;s name into the search bar below</li>
                    </ul>
                    <h4 className="margin-top-40">What investment are you looking for?</h4>
                    <div className="ajb-grid-row search">
                        <div className="ajb-col-8">
                            <MiniSearchBox />
                        </div>
                    </div>
                    <h4 className="margin-top-40">Can we help you with anything else?</h4>
                    <div className="ajb-grid-row margin-top-30 margin-botttom-50">
                        {ctaColumns}
                    </div>
                </div>
            </div>
        </div>
    </Main>
}

export async function getServerSideProps(context) {
    try {
        let instrumentData = await YouInvest.getNavigation();
        sendCacheHeaders(context);
        return { props: { instrumentData } }
    } catch (e) {
        Sentry.captureException(e);
        return {
            notFound: true
        }
    }
}
